import type { RentalManagerEnvironment } from './types';

export class RentalManagerBrowserEnvironment {
  static instance: RentalManagerEnvironment | null;

  static setInstance(instance: RentalManagerEnvironment): RentalManagerEnvironment {
    RentalManagerBrowserEnvironment.instance = instance;
    return RentalManagerBrowserEnvironment.instance;
  }

  static getInstance(): RentalManagerEnvironment {
    if (!RentalManagerBrowserEnvironment.instance) {
      throw new Error('RentalManagerBrowserEnvironment not initialized');
    }
    return RentalManagerBrowserEnvironment.instance;
  }
}
